import {
  Flex,
  IconInCircle,
  Text,
  IconNames,
  sizes,
  spaces,
} from '@electricjs/arc';

export const DetailSection = ({
  icon,
  label,
  children,
}: {
  icon: IconNames;
  label: string;
  children: React.ReactNode | React.ReactNode[];
}) => {
  const { size_32 } = sizes;
  const { space_m, space_xl } = spaces;

  return (
    <Flex flexDirection="column" width="100%" gap={space_m} px={space_m}>
      <Flex alignItems="center" gap={space_m}>
        <IconInCircle
          icon={icon}
          intent="primary"
          size={size_32}
          iconSize="small"
        />
        <Text variant="label-large">{label}</Text>
      </Flex>
      <Flex flexDirection="column" width="100%" gap={space_m} pl={space_xl}>
        {children}
      </Flex>
    </Flex>
  );
};
